class TvDrawer extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;

    document.addEventListener('click', this.handleTrigger);
    this.dialog.addEventListener('click', this.handleBackdrop);

    if (window.location.hash === '#total-value') this.open();
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleTrigger);
    this.dialog?.removeEventListener('click', this.handleBackdrop);
  }

  handleTrigger = (e) => {
    const link = e.target.closest('a[href*="#total-value"]');
    if (!link || this.dialog.contains(link)) return;
    e.preventDefault();
    this.open();
  };

  handleBackdrop = (e) => {
    if (e.target === this.dialog) this.dialog.close();
  };

  open() {
    if (this.dialog.open) return;
    const header = [...document.querySelectorAll('.header, .cart-header__bar')].find((el) => el.getClientRects().length && el.getBoundingClientRect().height);
    const top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    this.dialog.style.setProperty('--tv-drawer-top', `${Math.round(top)}px`);
    this.dialog.showModal();
  }
}

if (!customElements.get('tv-drawer')) customElements.define('tv-drawer', TvDrawer);
